import { useState } from "react";
import { Select, Table } from "antd";
import { useQuery } from "react-query";
import { useNavigate } from "react-router";
import { getCases } from "../../api/monitoring";
import CustomerLink from "../shared/CustomerLink";
import { Pill, timeAgo } from "./shared";

export const OUTCOME_LABELS = {
  no_action: "No action needed",
  account_restricted: "Account restricted",
  reported: "Reported to authorities",
  other: "Other",
};

export const caseColumns = [
  { title: "Case", dataIndex: "title", key: "title", render: (v) => <span className="font-bold">{v}</span> },
  {
    title: "Customer",
    key: "customer",
    render: (_, c) => <CustomerLink userId={c.userId} record={{ user: c.customer }} />,
  },
  { title: "Alerts", key: "alerts", render: (_, c) => c.alertIds?.length || 0 },
  {
    title: "Status",
    key: "status",
    render: (_, c) => (
      <div>
        <Pill className={c.status === "open" ? "bg-[#F2C94C33] text-[#B7791F]" : "bg-[#0000000D] text-[#4F4F4F]"}>{c.status}</Pill>
        {c.outcome && <div className="text-[12px] text-[#00000080]">{OUTCOME_LABELS[c.outcome]}</div>}
      </div>
    ),
  },
  { title: "Owner", dataIndex: "assignee", key: "assignee", render: (v) => <span className="text-[13px]">{v || "—"}</span> },
  { title: "Updated", dataIndex: "updatedAt", key: "updatedAt", render: (v) => <span className="text-[13px]">{timeAgo(v)}</span> },
];

const Cases = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [status, setStatus] = useState("open");
  const { data, isFetching } = useQuery(["monitoring-cases", page, status], () =>
    getCases({ page, ...(status !== "all" && { status }) }),
  );
  return (
    <div className="bg-white rounded-lg p-5 space-y-3">
      <div className="flex justify-between items-center">
        <div className="text-[13px] text-[#00000080]">Cases group related alerts for one customer. Escalate an alert to open one.</div>
        <Select
          value={status}
          onChange={(v) => {
            setStatus(v);
            setPage(1);
          }}
          className="w-[140px]"
          options={[
            { value: "open", label: "Open" },
            { value: "closed", label: "Closed" },
            { value: "all", label: "All" },
          ]}
        />
      </div>
      <Table
        rowKey="_id"
        loading={isFetching}
        dataSource={data?.cases || []}
        columns={caseColumns}
        rowClassName="cursor-pointer hover:bg-gray-50"
        onRow={(c) => ({ onClick: () => navigate(`/monitoring/cases/${c._id}`) })}
        pagination={{ current: page, pageSize: 20, total: data?.total || 0, onChange: setPage }}
      />
    </div>
  );
};

export default Cases;
